import { apiService } from './api.service';
import { CR_API_ENDPOINTS } from '../constants';
import { ClientDetail, CreateClientPayload, UpdateClientPayload } from '../types/clients.types';

class ClientsService {
  /**
   * Fetches all clients with their associated lenders.
   * @returns Array of clients with lenders
   */
  async getAll(): Promise<ClientDetail[]> {
    return apiService.get<ClientDetail[]>(CR_API_ENDPOINTS.CLIENTS);
  }

  /**
   * Fetches a single client by ID.
   * @param id - Client UUID
   * @returns The client with lenders
   */
  async getById(id: string): Promise<ClientDetail> {
    return apiService.get<ClientDetail>(`${CR_API_ENDPOINTS.CLIENTS}/${id}`);
  }

  /**
   * Creates a new client.
   * @param data - Client creation payload
   * @returns The created client
   */
  async create(data: CreateClientPayload): Promise<ClientDetail> {
    return apiService.post<ClientDetail>(CR_API_ENDPOINTS.CLIENTS, data);
  }

  /**
   * Updates an existing client.
   * @param id - Client UUID
   * @param data - Client update payload
   * @returns The updated client
   */
  async update(id: string, data: UpdateClientPayload): Promise<ClientDetail> {
    return apiService.put<ClientDetail>(`${CR_API_ENDPOINTS.CLIENTS}/${id}`, data);
  }

  /**
   * Deletes a client.
   * @param id - Client UUID
   */
  async delete(id: string): Promise<void> {
    return apiService.delete<void>(`${CR_API_ENDPOINTS.CLIENTS}/${id}`);
  }

  /**
   * Removes a lender association from a client.
   * @param clientId - Client UUID
   * @param lenderId - Lender UUID
   * @returns The updated client
   */
  async removeLender(clientId: string, lenderId: string): Promise<ClientDetail> {
    return apiService.delete<ClientDetail>(
      `${CR_API_ENDPOINTS.CLIENTS}/${clientId}/lenders/${lenderId}`,
    );
  }
}

export const clientsService = new ClientsService();
